module.exports = __webpack_public_path__ + "static/media/GRP200229014.e8bca02e.pdf";